import MaintenanceEstablishmentChoiceManualEntryProposalEstablishmentAccept from '@/features/maintenance/features/workflows/pages/Show/components/actions/establishmentChoice/manualEntryProposal/EstablishmentAccept'
import { MaintenanceForwardingData } from '@/features/maintenance/features/workflows/types/forwardings/maintenanceForwarding.type'
import { ManualEntryProposalShowData } from '../../../types/maintenanceManualEntryProposal.type'

type Props = {
  proposal: ManualEntryProposalShowData
  onAccepted?: () => void
}

const DiagnosticProposalAction = ({ proposal, onAccepted }: Props) => {
  const forwarding = {
    id: proposal.manual_entry?.forwarding?.id,
    establishment_choice_entry: { actual_proposal: { id: proposal.id } },
  } as MaintenanceForwardingData

  return (
    <MaintenanceEstablishmentChoiceManualEntryProposalEstablishmentAccept
      forwarding={forwarding}
      triggerLabel="Adicionar proposta"
      onAccepted={onAccepted}
    />
  )
}

export default DiagnosticProposalAction
